/** @format */

import { catchError, throwError } from 'rxjs';

import { AppointmentsTimespanEnum } from '@my-account/data-access/enums';
import { GameTimeDao } from '@my-account/data-access/dao';
import { Injectable } from '@angular/core';
import { MyAccountErrorLogKeys } from '@shared/data-access/enums';
import { formatDate } from '@angular/common';
import { MyAccountAnalyticsService } from '@shared/data-access/services';

@Injectable({
	providedIn: 'root'
})
export class AppointmentsService {
	constructor(
		private gameTimeDao: GameTimeDao,
		private myAccountAnalyticsService: MyAccountAnalyticsService
	) {}

	public fetchAppointments(timespan?: AppointmentsTimespanEnum) {
		if (!timespan) {
			return this.gameTimeDao
				.fetchAppointments()
				.pipe(catchError(this.handleFetchAppointmentsError));
		}
		const currentDate = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
		const options =
			timespan === AppointmentsTimespanEnum.UPCOMING
				? { startDate: currentDate }
				: { endDate: currentDate };
		return this.gameTimeDao
			.fetchAppointments(options)
			.pipe(catchError(this.handleFetchAppointmentsError));
	}

	private handleFetchAppointmentsError(err: never) {
		this.myAccountAnalyticsService.generateLogError(
			MyAccountErrorLogKeys.MYACCOUNT_APPOINTMENTS,
			`Failed to get appointments from GameTime.`,
			err
		);
		return throwError(() => err);
	}
}
